
import { mapState } from 'vuex'

export default {
  props: {
    productHandle: String
  },
  computed: {
    ...mapState({
      allProducts: state => state.products.all
    }),
    product () {
      console.log('from storePRoduct::: ', this.allProducts)
      console.log('from storePRoduct::: ', this.allProducts.find(product => product.handle === this.productHandle))
      return this.allProducts.find(product => product.handle === this.productHandle)
    }
  },
  mounted () {
    if (!this.product) {
      console.log('dispatched!')
      this.$store.dispatch('products/addProduct', this.productHandle)
    }
  }
}
